import { Form_Data } from './util.models';

export class Certificate {
    name: string;
    expiryDate: Date;
    file: any;
}


export class Certificates {
    id: string;
    document_name: string;
    document_url: string;
    expires_on: Date;
    verified_by: string;
    doctor_user_guid: string;
}

export class Certificate_data {
    api_data: Certificate = new Certificate();
    form_data: Form_Data = new Form_Data();
}


export class Pending_Certificates {
    id: string;
    document_name: string;
    document_url: string;
    verified_by: string;
    expires_on: Date;
    d_email: string;
    doctor_name: string;
    doctor_user_guid: string;
}